import _ from "lodash";
import { IRegion } from "../models/ProduktdefinitionModels";

export class ProduktinstruktionUtils {
    private static readonly moPrefix = "MO";

    static getRegioner(regioner: IRegion[]) {
        return _.chain(regioner)
            .filter(x => x.aktiv)
            .groupBy(s => s.marknadsomradeId)
            .map((resultatomraden, marknadsomradeId) => ({
                sekvensnummer: 0,
                text: resultatomraden[0].marknadsomradeNamn,
                value: ProduktinstruktionUtils.moPrefix + marknadsomradeId,
                children: _.orderBy(resultatomraden.map(s => (({
                    sekvensnummer: s.sekvensnummer,
                    text: s.namn,
                    value: s.id
                }))), s => s.sekvensnummer)
            }))
            .orderBy(x => x.text)
            .value();
    }

    static fakeMarknadsomradeGuid(guid: string) {
        return ProduktinstruktionUtils.moPrefix + guid;
    }

    // Filtrera bort marknadsområden
    static removeMarknadsomraden(regioner: string[]) {
        return regioner.filter(p => !p.startsWith(this.moPrefix));
    }
}
